import { setupWorker } from 'msw'
import { handlers } from './handlers'
import { isBrowser } from '../../utils/browser'

const worker = isBrowser() ? setupWorker(...handlers) : null

export { worker }
